export default __webpack_public_path__ + "static/media/448.59f3c981.jpg";